import RuleRoundedIcon from '@mui/icons-material/RuleRounded';
import { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

export const CellRulesIcon: React.FC<SvgIconProps> = (props) => <RuleRoundedIcon {...props} />;

export default CellRulesIcon;
